const unitMultiplier = 4;

export default unitMultiplier;
